import React, { useState } from "react";
import { toast } from "sonner";
import { uploadTemplate, formatApiErrorDetail } from "../lib/api";

export default function UploadTemplateDialog({ open, onClose, onUploaded }) {
  const [manifestF, setManifestF] = useState(null);
  const [bundleF, setBundleF] = useState(null);
  const [thumbF, setThumbF] = useState(null);
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const submit = async () => {
    if (!manifestF || !bundleF) { toast.error("manifest.json and bundle.js are required"); return; }
    setBusy(true);
    try {
      const r = await uploadTemplate(manifestF, bundleF, thumbF);
      toast.success(`Template “${r.name}” uploaded`);
      onUploaded && onUploaded(r);
      onClose();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Upload failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="scrim open" onClick={(e) => { if (e.target.classList.contains("scrim")) onClose(); }} data-testid="upload-template-dialog">
      <div className="modal" role="dialog" aria-modal="true" style={{ width: "min(520px,94vw)" }}>
        <div className="modal-head">
          <h3>Upload a template</h3>
          <button className="iconbtn" onClick={onClose} data-testid="upload-close" aria-label="Close">✕</button>
        </div>
        <div className="modal-body">
          <p className="hint-inline" style={{ marginLeft: 0 }}>
            Build against the CloudTV Creative SDK, then upload the bundle. It appears in your Standard rail and renders in the sandboxed preview.
          </p>
          <div className="field">
            <label>manifest.json <span className="dim">· metadata + inspector schema + declared events</span></label>
            <input type="file" accept=".json,application/json" data-testid="upload-manifest"
              onChange={(e) => setManifestF(e.target.files?.[0] || null)} />
          </div>
          <div className="field">
            <label>bundle.js <span className="dim">· calls CloudTV.defineTemplate(...)</span></label>
            <input type="file" accept=".js,text/javascript,application/javascript" data-testid="upload-bundle"
              onChange={(e) => setBundleF(e.target.files?.[0] || null)} />
          </div>
          <div className="field">
            <label>Thumbnail <span className="dim">· optional</span></label>
            <input type="file" accept="image/*" data-testid="upload-thumb"
              onChange={(e) => setThumbF(e.target.files?.[0] || null)} />
          </div>
          <div className="urlacts">
            <button className="btn primary" onClick={submit} disabled={busy} data-testid="upload-submit">
              {busy ? "Uploading…" : "Upload template"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
